"use client";

import DesktopMenu from "@repo/ui/components/Header/DesktopMenu";
import { useZonePathname } from "@repo/ui/navigation";
import type { Header as HeaderType } from "@repo/ui/types/cms/common";

const allowedPaths = ["/", "/home", "profile", "/flights"];
interface DesktopMenuGateProps {
  header: HeaderType;
}

export default function DesktopMenuGate({ header }: DesktopMenuGateProps) {
  // Locale-stripped: `allowedPaths` holds unprefixed literals, so a raw
  // usePathname() ("/cl/es") would never match and the menu would never render.
  const pathname = useZonePathname();
  const shouldShowDesktopMenu = allowedPaths.includes(pathname);
  return shouldShowDesktopMenu ? <DesktopMenu header={header} /> : null;
}
